import { AntaresStateInterface } from "./models/AntaresState.interface";

export const initialState: AntaresStateInterface = {
  loading: false,
};
